var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_5",
    "data-name": "Rounded Rectangle 5",
    className: "cls-1",
    x: 5,
    y: 6,
    width: 14,
    height: 13,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_5_copy_5",
    "data-name": "Rounded Rectangle 5 copy 5",
    className: "cls-1",
    x: 24,
    y: 6,
    width: 21,
    height: 13,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_5_copy_4",
    "data-name": "Rounded Rectangle 5 copy 4",
    className: "cls-1",
    x: 5,
    y: 25,
    width: 40,
    height: 20,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.358,35.7l37.254-4.213v12.64H6.358V35.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.fa0a36a3eaa27d5cf125e44761bd0c2f.svg";
export { ForwardRef as ReactComponent };